var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 95v407h175.27l103.685-188.5-103.685-218.5z",
    fill: "#edf5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.27 95h175.27v407h-175.27z",
    fill: "#d5e8fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.546 178.5h90v90h-90z",
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.27 178.5h127.214v30h-127.214z",
    fill: "#66a1f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.27 238.5h127.214v30h-127.214z",
    fill: "#66a1f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.546 298.5v30h127.724l11.475-15-11.475-15z",
    fill: "#89d2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.27 298.5h127.214v30h-127.214z",
    fill: "#66a1f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.546 388.5h127.724l11.475-15-11.475-15h-127.724z",
    fill: "#89d2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.27 358.5h127.214v30h-127.214z",
    fill: "#66a1f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.546 448.5h127.724l11.475-15-11.475-15h-127.724z",
    fill: "#89d2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.27 418.5h127.214v30h-127.214z",
    fill: "#66a1f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.402 40v15h-47.8v60h79.668l25.711-42.176-25.711-62.824c-17.602 0-31.868 13.43-31.868 30z",
    fill: "#61729b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.938 55h-47.801v-15c0-8.28-3.569-15.78-9.337-21.21s-13.735-8.79-22.53-8.79v105h79.668z",
    fill: "#47568c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m480.135 128.2c-17.599 0-31.865 14.266-31.865 31.865v28.135l15.932 15.3 15.932-15.3 16.705-22.35z",
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.135 128.2v60l18.513 15.3 13.352-15.3v-28.135c0-17.599-14.266-31.865-31.865-31.865z",
    fill: "#ff415b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.27 188.2v220.6l31.86 60 .005-.009 23.218-187.791-23.218-92.8z",
    fill: "#fee378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 188.2h-31.865v280.591l31.865-59.991z",
    fill: "#fabe2c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard2);
export default __webpack_public_path__ + "static/media/clipboard2.df20e927.svg";
export { ForwardRef as ReactComponent };